import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { IBroadcastRecipient, OptedInStatus } from '../types';
import { Checkbox } from '@common/components';
import { Button } from '@common/components/Button/Button';
import { ButtonTypes } from '@common/components/Button/types';
import theme from '@common/theme';
import { StatusBadge } from '../StatusBadge';
import { ActionsWrapper, CenteredContainer, CheckboxWrapper } from './styles';
import Divider from '@common/components/Divider/Divider';

interface IBroadcastTableCallbacks {
  selectedRecipientIds: string[];
  onToggleSelection: (recipientId: string, selected: boolean) => void;
  onOptIn: (recipientId: string, email: string) => void;
  onDelete: (recipientId: string, email: string) => void;
}

export const prepareBroadcastRecipientsColumns = (callbacks: IBroadcastTableCallbacks): ColumnDef<IBroadcastRecipient>[] => {
  return [
    {
      accessorKey: 'email',
      header: 'Email address',
      cell: (info) => <span>{info.getValue() as string}</span>,
    },
    {
      id: 'sendThisBroadcast',
      header: 'Send this broadcast',
      size: 145,
      cell: (info) => {
        const recipient = info.row.original;
        const isDisabled = recipient.status === OptedInStatus.No || recipient.status === OptedInStatus.Expired;
        const isChecked = callbacks.selectedRecipientIds.includes(recipient.id);

        return (
          <CenteredContainer>
            <CheckboxWrapper $isDisabled={isDisabled}>
              <Checkbox
                name={`send-broadcast-${recipient.id}`}
                isChecked={isChecked}
                onChange={(e) => callbacks.onToggleSelection(recipient.id, e.target.checked)}
                disabled={isDisabled}
              />
            </CheckboxWrapper>
          </CenteredContainer>
        );
      },
    },
    {
      accessorKey: 'status',
      header: 'Opted in',
      size: 130,
      cell: (info) => <StatusBadge status={info.getValue() as OptedInStatus} />,
    },
    {
      id: 'queued',
      header: 'Queued',
      cell: (info) => {
        const recipient = info.row.original;
        if (recipient.status === OptedInStatus.Yes) {
          return <CenteredContainer>N/A</CenteredContainer>;
        }
        return <CenteredContainer>{recipient.pendingBroadcastCount ?? 0}</CenteredContainer>;
      },
    },
    {
      id: 'actions',
      header: 'Actions',
      size: 200,
      cell: (info) => {

  const recipient = info.row.original;
  const showOptIn = recipient.status === OptedInStatus.No || recipient.status === OptedInStatus.Expired;
  const handleOptIn = () => {
    // For both No and Expired, trigger the same callback
    callbacks.onOptIn(recipient.id, recipient.email);
  };

        return (
          <ActionsWrapper>
            {showOptIn && (
              <Button
                type={ButtonTypes.TEXT}
                text="Opt in"
                height={25}
                color={theme.elements.primaryMedium}
                onClick={handleOptIn}
              />
            )}
            {showOptIn && <Divider type="vertical" size="30px" />}
            <Button
              type={ButtonTypes.TEXT}
              text="Delete"
              height={25}
              color={theme.colors.red}
              onClick={() => callbacks.onDelete(recipient.id, recipient.email)}
            />
          </ActionsWrapper>
        );
      },
    },
  ];
};
